import { reportTypeStage } from '../../config/reportTypes';
import type { NextAction } from './nextAction';
import type { StageBoardsModel } from './stageBoards';

export type NextStepAnchor = 'stage-1' | 'interlock' | 'stage-2' | 'decision';
export interface SiteNextStep extends NextAction {
  anchor: NextStepAnchor;
}

/** Display projection only. The canonical resolver remains the action authority. */
export function buildSiteNextStep(next: NextAction, boards: StageBoardsModel): SiteNextStep {
  const screened = boards.screening.state === 'complete' || boards.screening.state === 'nothing-required';
  let anchor: NextStepAnchor;
  if (next.cleared) anchor = 'decision';
  else if (next.key.startsWith('stage2:') || next.key === 'hold:power-strategy-undeclared') anchor = 'interlock';
  else if (screened && boards.validation.scenario?.needed && (
    next.key === 'hold:stage-2-locked'
    || next.pathAction.kind === 'generation-impact' && next.pathAction.focus !== 'layout'
    || next.pathAction.kind === 'request-access' && next.pathAction.destination === 'generation-impact'
  )) anchor = 'interlock';
  else if ('reportType' in next.pathAction) anchor = reportTypeStage(next.pathAction.reportType) === 1 ? 'stage-1' : 'stage-2';
  else if (['bom', 'financial-inputs', 'engineering-source', 'generation-impact'].includes(next.pathAction.kind)) anchor = 'stage-2';
  else anchor = !screened ? 'stage-1' : boards.validation.scenario?.needed ? 'interlock' : 'stage-2';
  return { ...next, anchor };
}
